export default {
  "DOUBTS": "Doubts"
};
